import KibernetesSpinner from './kibernetes_spinner';

const NAME_UTIL = "KibernetesPagination";

export default class KibernetesPagination {
  #url;
  #ele;
  #q = '';
  #tipo = '';
  #actual = 0;
  #total = 0;
  #page = 1;
  #pageSize = 10;
  #spinner;

  #nextPageEvent = new CustomEvent("kib.pagination.pageLoaded", { detail: this });
  #lastPageEvent = new CustomEvent("kib.pagination.lastPageLoaded", { detail: this });

	constructor( url, elenco, total=0, pageSize=10 ) {
    this.#url = url;
    this.#total = total;
    this.#actual =  (total >= pageSize) ? pageSize : total;
    this.#page = 1;
    this.#pageSize = pageSize;
    this.#ele = elenco;

    this.#spinner = new KibernetesSpinner();
	}

  firstPage( p={} ) {
    this.#ele.html = "";
    this.#actual = 0;
    this.#total = 0;
    this.#page = 1;
    this.#fetchData( this.#page, this.#pageSize, p );
  }

  nextPage( p={} ) {
    this.#page = this.#page + 1;
    this.#fetchData( this.#page, this.#pageSize, p );
  }

  loadAll() {
    this.#ele.html = "";
    this.#actual = 0;
    this.#total = 0;
    this.#page = 1;
    this.#fetchData( this.#page, 99999999 );
  }

  #fetchData( page, pageSize, p={} ) {
    const params = new URLSearchParams();
    params.set( "page", page );
    params.set( "pageSize", pageSize );
    Object.keys( p ).forEach(key => {
        params.set( key,p[key] );
    });

    this.#spinner.show();
    const url = this.#url + '?' + params;
    var p = fetch( url )
      .then( (response) => response.json() )
      .then( (data) => {
        this.#total = data.total;
        for (const s of data.renderedPages) {
          this.#ele.html = this.#ele.html + s;
        }
        this.#actual = this.#actual + data.renderedPages.length;
        if ( this.#actual >= this.#total ) {
          this.#ele.dispatchEvent( this.#lastPageEvent );
        } else {
          this.#ele.dispatchEvent( this.#nextPageEvent );
        }
        this.#spinner.hide();
      });
  }
}
